import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { useNavigate, Link } from "react-router-dom";
// import { toast } from "react-toastify";
import { ChevronDown } from "lucide-react";
import dayjs from "dayjs";
import { DateRange } from "react-date-range";
import Bluedart from "../../../../assets/bluedart.png";
import Delehivery from "../../../../assets/delehivery.png";
import EcomExpress from "../../../../assets/ecom-expresss.avif";
import Shadowfax from "../../../../assets/shadowfax.png";
import Xpressbees from "../../../../assets/xpressbees.png";
import Shiprocket from "../../../../assets/shiprocket.webp";
import NimbusPost from "../../../../assets/nimbuspost.webp";
import ShreeMaruti from "../../../../assets/shreemaruti.png";
import DTDC from "../../../../assets/dtdc.png";
import Amazon from "../../../../assets/amazon.jpg";
import Smartship from "../../../../assets/bluedart.png"
import ThreeDotLoader from "../../../../Loader"
import Cookies from "js-cookie";
import { Notification } from "../../../../Notification";


const CompleteWeightDiscrepancy = () => {
  const [orders, setOrders] = useState([]);
  const [userQuery, setUserQuery] = useState("");
  const [userSuggestions, setUserSuggestions] = useState([]);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [page, setPage] = useState(1);
  const [customRange, setCustomRange] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    },
  ]);
  const [provider, setProvider] = useState("");
  const [showProviderDropdown, setShowProviderDropdown] = useState(false);
  const providerRef = useRef(null);
  const [showCalendar, setShowCalendar] = useState(false);
  const calendarRef = useRef();
  const [dateRange, setDateRange] = useState("");
  const [showDateDropdown, setShowDateDropdown] = useState(false);
  const dateDropdownRef = useRef(null);
  const [customDateLabel, setCustomDateLabel] = useState("");
  const [limit, setLimit] = useState(20);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);
  const [awbNumber, setAwbNumber] = useState("");
  const [orderId, setOrderId] = useState("");
  const [selectedDispute, setSelectedDispute] = useState([]);

  const pageOptions = [20, 50, 75, 100, "all"];

  const REACT_APP_BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
  const carrierLogos = {
    Bluedart,
    Delhivery: Delehivery,
    EcomExpress,
    Shadowfax,
    Xpressbees,
    NimbusPost,
    Shiprocket,
    "Shree Maruti": ShreeMaruti,
    ShreeMaruti,
    DTDC,
    Dtdc: DTDC,
    Amazon,
    "Amazon Shipping": Amazon,
    Smartship
  };
  const navigate = useNavigate();

  const getDateRange = () => {
    const today = dayjs();
    switch (dateRange) {
      case "today":
        return {
          fromDate: today.startOf("day").toISOString(),
          toDate: today.endOf("day").toISOString(),
        };
      case "yesterday":
        return {
          fromDate: today.subtract(1, "day").startOf("day").toISOString(),
          toDate: today.subtract(1, "day").endOf("day").toISOString(),
        };
      case "last5days":
        return {
          fromDate: today.subtract(5, "day").startOf("day").toISOString(),
          toDate: today.endOf("day").toISOString(),
        };
      case "thisMonth":
        return {
          fromDate: today.startOf("month").toISOString(),
          toDate: today.endOf("month").toISOString(),
        };
      case "lastMonth":
        const lastMonth = today.subtract(1, "month");
        return {
          fromDate: lastMonth.startOf("month").toISOString(),
          toDate: lastMonth.endOf("month").toISOString(),
        };
      case "custom":
        return {
          fromDate: customRange[0].startDate.toISOString(),
          toDate: customRange[0].endDate.toISOString(),
        };
      default:
        return {};
    }
  };

  const handleApplyCustomDate = () => {
    setShowCalendar(false);
    const start = dayjs(customRange[0].startDate).format("MMM D");
    const end = dayjs(customRange[0].endDate).format("MMM D");

    setCustomDateLabel(`${start} - ${end}`);
    setDateRange("custom"); // Ensure it's always "custom"
    fetchDiscrepancy();
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        providerRef.current &&
        dateDropdownRef.current &&
        !providerRef.current.contains(event.target) &&
        !dateDropdownRef.current.contains(event.target)
      ) {
        setShowProviderDropdown(false);
        setShowDateDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    fetchDiscrepancy();
  }, [selectedUserId, dateRange, page, limit, orderId, awbNumber, provider]);

  const fetchDiscrepancy = async () => {
    try {
      const token = Cookies.get("session");
      const { fromDate, toDate } = getDateRange();
      setLoading(true);
      const response = await axios.get(
        `${REACT_APP_BACKEND_URL}/dispreancy/getAllDiscrepancy`,
        {
          headers: { Authorization: `Bearer ${token}` },
          params: {
            userSearch: selectedUserId || "",
            fromDate,
            toDate,
            page,
            limit,
            orderId,
            awbNumber,
            provider,
            status: "Accepted",
          },
        }
      );
      console.log("trans", response.data.results);
      setOrders(response.data.results || []);
      setTotal(response.data.total || 0);
      setLoading(false);
    } catch (error) {
      Notification("Error fetching transactions", "error");
    }
  };
  const fetchDiscrepancysManually = async (userId) => {
    try {
      const token = Cookies.get("session");
      const { fromDate, toDate } = getDateRange();
      setLoading(true);
      const response = await axios.get(
        `${REACT_APP_BACKEND_URL}/dispreancy/getAllDiscrepancy`,
        {
          headers: { Authorization: `Bearer ${token}` },
          params: {
            userSearch: userId || "",
            fromDate,
            toDate,
            page: 1, // when manually triggered, reset to first page
            limit,
            orderId,
            awbNumber,
            provider,
            status: "Accepted",
          },
        }
      );
      console.log("res", response);
      setOrders(response.data.results || []);
      setTotal(response.data.total || 0);
      setLoading(false);
    } catch (error) {
      Notification("Error fetching transactions", "error");
    }
  };

  const handleUserSearch = async (query) => {
    setUserQuery(query);
    if (query.length < 2) {
      setUserSuggestions([]);
      setSelectedUserId(null);
      return;
    }
    try {
      const res = await axios.get(`${REACT_APP_BACKEND_URL}/admin/searchUser`, {
        params: { query },
      });
      setUserSuggestions(res.data.users || []);
    } catch {
      setUserSuggestions([]);
    }
  };

  const handleTrackingByAwb = (awb) => {
    navigate(`/dashboard/order/tracking/${awb}`);
  };

  const handleSelectAll = () => {
    if (selectedDispute.length === orders.length) {
      setSelectedDispute([]);
    } else {
      setSelectedDispute(orders.map((dispute) => dispute._id));
    }
  };

  const handleCheckboxChange = (weightId) => {
    // console.log("weightId", weightId);
    setSelectedDispute((prev) =>
      prev.includes(weightId)
        ? prev.filter((id) => id !== weightId)
        : [...prev, weightId]
    );
  };

  const handleExport = async () => {
    if (selectedDispute.length === 0) {
      Notification("Please select at least one order to export.", "info");
      return;
    }

    console.log("Selected Disputes for Export:", selectedDispute);
    try {
      const token = Cookies.get("session");
      const response = await axios.post(
        `${REACT_APP_BACKEND_URL}/dispreancy/exportWeightDiscrepancy`,
        { disputeId: selectedDispute }, // array of selected transaction IDs
        {
          headers: { Authorization: `Bearer ${token}` },
          responseType: "blob", // important to handle file download
        }
      );

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "weight discrepancy_export.csv"); // Set desired file name, CSV extension
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      Notification("Export successful!", "success");
    } catch (error) {
      console.error("Export error:", error);
      Notification("Failed to export passbook data. Please try again later.", "error");
    }
  };

  const handleClearFilters = () => {
    setUserQuery("");
    setSelectedUserId("");
    setAwbNumber("");
    setProvider("");
    setDateRange([{ startDate: null, endDate: null, key: "selection" }]);
  }

  return (
    <div>
      {/* Desktop Table */}
      <div>
        {/* Filter Section */}
        <div className="flex sm:flex-row flex-col gap-2 mb-2 relative">
          {/* User Search */}
          <div className="relative">
            <input
              type="text"
              value={userQuery}
              onChange={(e) => handleUserSearch(e.target.value)}
              placeholder="Search user by ID, name, or email"
              className="w-full focus:outline-none sm:w-[200px] px-3 rounded-lg border-2 placeholder:text-gray-400 placeholder:text-[12px] h-9 text-[12px] font-[600]" // Uniform height
            />
            {userSuggestions.length > 0 && (
              <div className="absolute z-10 w-full bg-white border rounded mt-1 max-h-60 overflow-y-auto">
                {userSuggestions.map((user, index) => (
                  <div
                    key={user._id}
                    className={`flex cursor-pointer group transition-all duration-200 ${index !== userSuggestions.length
                      ? "border-b border-gray-300 hover:bg-gray-100"
                      : ""
                      } group-hover:bg-gray-100`}
                    onClick={() => {
                      setSelectedUserId(user._id);
                      setUserQuery(user.fullname);
                      setUserSuggestions([]);
                      setPage(1);
                      fetchDiscrepancysManually(user._id);
                    }}
                  >
                    {/* Left column: User ID */}
                    <div className="w-1/4 flex items-center justify-center p-2 transition-colors duration-200">
                      <p className="text-[12px] text-gray-400 group-hover:text-[#632C9D] font-medium text-center truncate">
                        {user.userId}
                      </p>
                    </div>

                    {/* Right column: Fullname and Email */}
                    <div className="w-3/4 flex flex-col justify-center py-[6px] pr-2 leading-tight transition-colors duration-200">
                      <p className="text-[13px] text-gray-500 group-hover:text-[#632C9D] font-medium truncate transition-colors duration-200">
                        {user.fullname}
                      </p>
                      <p className="text-[11px] text-gray-400 truncate">
                        {user.email}
                      </p>
                      <p className="text-[11px] text-gray-400 truncate">
                        {user.phoneNumber}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>

          <div className="flex items-center">
            {/* Input Field for AWB Number only */}
            <input
              type="text"
              value={awbNumber}
              onChange={(e) => setAwbNumber(e.target.value)}
              placeholder="Search AWB Number"
              className="px-3 h-9 border-2 placeholder:text-gray-400 rounded-lg text-[12px] font-[600] flex-1 outline-none"
            />
          </div>

          <div className="flex gap-2 justify-between w-full">
            <div className="flex gap-2 w-full">
              {/* Date Range Dropdown */}
              <div className="relative w-full sm:w-auto" ref={dateDropdownRef}>
                <button
                  onClick={() => setShowDateDropdown((prev) => !prev)}
                  className="w-full h-9 px-3 sm:w-[140px] border-2 font-[600] rounded-lg text-gray-400 text-left sm:text-[12px] text-[12px] bg-white flex justify-between items-center"
                  type="button"
                >
                  {customDateLabel || "Dates"}
                  <ChevronDown
                    className={`w-4 h-4 transform transition-transform ${showDateDropdown ? "rotate-180" : ""
                      }`}
                  />
                </button>

                {showDateDropdown && (
                  <ul className="absolute z-30 w-full mt-1 bg-white border-2 text-gray-500 rounded-lg shadow-lg max-h-60 overflow-y-auto text-[12px]">
                    {[
                      // { value: "", label: "Dates" },
                      { value: "today", label: "Today" },
                      { value: "yesterday", label: "Yesterday" },
                      { value: "last5days", label: "Last 5 Days" },
                      { value: "thisMonth", label: "This Month" },
                      { value: "lastMonth", label: "Last Month" },
                      {
                        value: "custom",
                        label: customDateLabel
                          ? `Custom: ${customDateLabel}`
                          : "Custom",
                      },
                    ].map((item) => (
                      <li
                        key={item.value || "default"}
                        className={`px-3 py-2 cursor-pointer hover:bg-purple-50 ${dateRange === item.value ? "bg-purple-100 font-[600]" : ""
                          }`}
                        onClick={() => {
                          setDateRange(item.value);
                          setShowDateDropdown(false);
                          if (item.value === "custom") {
                            setShowCalendar(true);
                          } else {
                            setShowCalendar(false);
                          }
                        }}
                      >
                        {item.label}
                      </li>
                    ))}
                  </ul>
                )}

                {/* Calendar Dropdown */}
                {showCalendar && (
                  <div
                    ref={calendarRef}
                    className="absolute z-30 mt-2 bg-white shadow-lg rounded p-2 w-[350px]"
                  >
                    <DateRange
                      editableDateInputs={true}
                      onChange={(item) => setCustomRange([item.selection])}
                      moveRangeOnFirstSelection={false}
                      ranges={customRange}
                      maxDate={new Date()}
                      showDateDisplay={false}
                    />
                    <button
                      onClick={handleApplyCustomDate}
                      className="w-full mt-2 bg-[#632C9D] text-white text-sm py-1 px-3 rounded hover:bg-purple-600"
                    >
                      Apply
                    </button>
                  </div>
                )}
              </div>

              {/* Provider Filter */}
              <div className="relative w-full sm:w-auto" ref={providerRef}>
                <button
                  onClick={() => setShowProviderDropdown((prev) => !prev)}
                  className="w-full sm:w-[140px] h-9 px-3 border-2 rounded-lg text-left font-[600] text-gray-400 text-[12px] bg-white flex justify-between items-center"
                  type="button"
                >
                  <span>{provider || "Provider"}</span>
                  <ChevronDown
                    className={`w-4 h-4 transition-transform duration-200 ${showProviderDropdown ? "rotate-180" : ""
                      }`}
                  />
                </button>
                {showProviderDropdown && (
                  <ul className="absolute z-40 text-gray-500 w-full mt-1 bg-white border rounded-lg shadow-lg max-h-60 overflow-y-auto text-[12px]">
                    {["Delhivery", "DTDC", "EcomExpress", "Amazon"].map((s) => (
                      <li
                        key={s || "empty"}
                        className={`px-3 py-2 cursor-pointer hover:bg-purple-50 ${provider === s ? "bg-purple-100 font-[600]" : ""
                          }`}
                        onClick={() => {
                          setProvider(s);
                          setShowProviderDropdown(false);
                        }}
                      >
                        {s || "Provider"}
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            </div>

            <button
              className="px-3 h-9 sm:w-none text-[10px] sm:text-[12px] border-2 border-gray-100 rounded-lg font-[600] text-white bg-[#632C9D] hover:bg-purple-500 transition whitespace-nowrap"
              onClick={handleClearFilters}
              type="button"
            >
              Clear
            </button>
            <button className={`rounded-lg sm:text-[12px] border-2 border-gray-100 text-[10px] px-3 h-9 font-[600] justify-center items-center ${selectedDispute.length === 0
              ? "border-white bg-gray-300 text-[10px] sm:text-[12px] cursor-not-allowed text-gray-500"
              : "text-white border-[#632C9D] bg-[#632C9D] text-[10px] sm:text-[12px]"
              }`} onClick={handleExport}>
              Export
            </button>
          </div>
        </div>
      </div>
      <div className="hidden md:block overflow-x-auto">
        <table className="min-w-full bg-white border border-gray-300 rounded-lg shadow-md">
          {/* Table Head */}
          <thead>
            <tr className="text-white bg-[#632C9D] border border-[#632C9D] text-[12px]">
              <th className="py-2 px-3 text-left">
                <input
                  type="checkbox"
                  checked={
                    selectedDispute.length === selectedDispute.length &&
                    selectedDispute.length > 0
                  }
                  onChange={handleSelectAll}
                  className="cursor-pointer accent-[#632C9D] w-4"
                />
              </th>
              <th className="py-2 px-3 text-left">User Details</th>
              <th className="py-2 px-3 text-left">Product Details</th>
              <th className="py-2 px-3 text-left">Upload Date</th>
              <th className="py-2 px-3 text-left">Shipping Details</th>
              <th className="py-2 px-3 text-left">Applied Weight</th>
              <th className="py-2 px-3 text-left">Charged Weight</th>
              <th className="py-2 px-3 text-left">Excess Weight & Charges</th>
              <th className="py-2 px-3 text-left">Status</th>
            </tr>
          </thead>

          {/* Table Body */}
          <tbody>
            {loading ? (
              <tr>
                <td colSpan="9" className="text-center py-4">
                  <ThreeDotLoader />
                </td>
              </tr>
            ) : orders.length === 0 ? (
              <tr>
                <td colSpan="9" className="text-center py-4">
                  No pending weight discrepancies found.
                </td>
              </tr>
            ) : (
              orders.map((order, index) => (
                <tr
                  key={index}
                  className="border-t hover:bg-gray-50 transition-all text-xs md:text-[12px] lg:text-[12px]"
                >
                  <td className="py-2 px-3 whitespace-nowrap">
                    <input
                      type="checkbox"
                      checked={selectedDispute.includes(order._id)}
                      onChange={() => handleCheckboxChange(order._id)}
                      className="cursor-pointer accent-[#632C9D] w-4"
                    />
                  </td>
                  <td className="py-2 px-3 whitespace-nowrap">
                    <p className="text-[#632C9D]">{order.user.userId}</p>
                    <p>{order.user.name}</p>
                    <p
                      className="text-gray-500 truncate max-w-[120px]"
                      title={order.user.email} // Shows full email on hover
                    >
                      {order.user.email}
                    </p>
                    <p className="text-gray-500">{order.user.phoneNumber}</p>
                  </td>

                  <td className="py-2 px-3 whitespace-nowrap text-gray-500" style={{ maxWidth: "180px", width: "130px" }}>
                    <p>
                      <span className="font-[600]">Product Name:</span>{" "}
                      <span
                        className="inline-block w-36 truncate align-bottom"
                        title={order.productDetails
                          .map((item) => item.name)
                          .join(", ")}
                      >
                        {order.productDetails
                          .map((item) => item.name)
                          .join(", ")}
                      </span>
                    </p>
                    <p className="break-words whitespace-normal">
                      <span className="font-bold">SKU:</span>{" "}
                      {order.productDetails.map((item) => item.sku).join(", ")}
                    </p>
                    <p>
                      <span className="font-bold">QTY:</span>{" "}
                      {order.productDetails
                        .map((item) => item.quantity)
                        .join(", ")}
                    </p>
                  </td>
                  <td className="py-2 px-3 whitespace-nowrap">
                    <p>{new Date(order.createdAt).toLocaleTimeString()}</p>
                    <p>{new Date(order.createdAt).toLocaleDateString()}</p>
                  </td>

                  <td className="py-2 px-3 whitespace-nowrap text-gray-500">
                    <p>
                      <span className="font-bold">AWB: </span>
                      <span
                        onClick={() => handleTrackingByAwb(order.awbNumber)}
                        className="text-[#632C9D] cursor-pointer"
                      >
                        {order.awbNumber}
                      </span>
                    </p>
                    <p className="text-gray-500">{order.courierServiceName}</p>
                  </td>
                  <td className="py-2 px-3 whitespace-nowrap text-gray-500">
                    <p className="font-[600]">
                      Applied weight: {order.enteredWeight.applicableWeight} Kg
                    </p>
                    <p>Dead Weight: {order.enteredWeight.deadWeight} Kg</p>
                    <div className="text-gray-500">
                      <p>Volumetric weight:</p>
                      <p>
                        {(
                          ((order.enteredWeight?.volumetricWeight?.length ||
                            0) *
                            (order.enteredWeight?.volumetricWeight?.breadth ||
                              0) *
                            (order.enteredWeight?.volumetricWeight?.height ||
                              0)) /
                          5000
                        ).toFixed(2)}{" "}
                        Kg ({order.enteredWeight?.volumetricWeight?.length || 0}
                        cm x{" "}
                        {order.enteredWeight?.volumetricWeight?.breadth || 0}cm
                        x {order.enteredWeight?.volumetricWeight?.height || 0}
                        cm)
                      </p>
                    </div>
                  </td>
                  <td className="py-2 px-3 whitespace-nowrap text-gray-500">
                    <p className="font-[600]">
                      Charged weight: {order.chargedWeight.applicableWeight} Kg
                    </p>
                    <p>Dead Weight: {order.chargedWeight.deadWeight} Kg</p>
                    {order.chargedDimension?.length &&
                      order.chargedDimension?.breadth &&
                      order.chargedDimension?.height && (
                        <p className="text-gray-500 text-[10px]">
                          Volumetric weight:{" "}
                          {(
                            (order.chargedDimension.length *
                              order.chargedDimension.breadth *
                              order.chargedDimension.height) /
                            5000
                          ).toFixed(2)}{" "}
                          Kg ({order.chargedDimension.length}cm x{" "}
                          {order.chargedDimension.breadth}cm x{" "}
                          {order.chargedDimension.height}cm)
                        </p>
                      )}
                  </td>

                  <td className="py-2 px-3 whitespace-nowrap text-gray-500" style={{ maxWidth: "230px", width: "180px" }}>
                    <p className="font-medium">
                      <span className="font-[600]">Excess Weight:</span>
                      {order.excessWeightCharges.excessWeight} Kg
                    </p>
                    <p className="font-medium">
                      <span className="font-[600]">Excess Charges:</span>{" "}
                      ₹{Number(order.excessWeightCharges.excessCharges || 0).toFixed(2)}
                    </p>

                    <p className="font-medium">
                      <span className="font-[600]">Pending Amount:</span>
                      ₹{Number(order.excessWeightCharges.pendingAmount || 0).toFixed(2)}
                    </p>
                  </td>
                  <td className="py-2 px-3 whitespace-nowrap" style={{ maxWidth: "130px", width: "100px" }}>
                    <span className="px-2 py-1 rounded text-[10px] bg-purple-100 text-purple-700">
                      {order.adminStatus}
                    </span>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      <div className="block md:hidden space-y-4">
        <div className="p-1 bg-slate-200 rounded-md flex gap-3 items-center">
          <input
            type="checkbox"
            checked={
              selectedDispute.length === orders.length && orders.length > 0
            }
            onChange={handleSelectAll}
            className="cursor-pointer accent-[#632C9D] w-3 h-3"
          />
          <span className="text-[10px] font-[600]">Select All</span>
        </div>
        {loading ? (
          <div className="text-center py-4">
            <ThreeDotLoader />
          </div>
        ) : orders.length === 0 ? (
          <div className="text-center py-4">
            No pending weight discrepancies found.
          </div>
        ) : (
          orders.map((order, index) => (
            <div
              key={index}
              className="rounded-lg shadow-sm border border-gray-200 bg-white overflow-hidden text-[12px]"
            >
              {/* Courier Section */}
              <div className="flex items-center justify-between bg-purple-50 px-3 py-2 border-t text-[11px]">
                <div className="flex items-center gap-2">
                  <input
                    type="checkbox"
                    checked={selectedDispute.includes(order._id)}
                    onChange={() => handleCheckboxChange(order._id)}
                    className="cursor-pointer accent-[#632C9D] w-3 h-3"
                  />
                  {(() => {
                    // Find a key that matches part of the courierServiceName
                    const logoKey = Object.keys(carrierLogos).find((key) =>
                      order.courierServiceName?.toLowerCase().includes(key.toLowerCase())
                    );
                    const logoSrc = carrierLogos[logoKey] || "/courier-placeholder.png";

                    return (
                      <img
                        src={logoSrc}
                        alt="courier"
                        className="w-6 h-6 border-2 border-gray-300 rounded-full object-contain"
                      />
                    );
                  })()}
                  <span className="font-[600] text-gray-500">
                    {order.courierServiceName}
                  </span>
                </div>
                <span className="font-[600] text-gray-500">
                  AWB : <span className="text-[#632C9D]">{order.awbNumber}</span>
                </span>
              </div>

              {/* Shipment Header */}
              <div className="px-3 pt-1 font-[600] text-gray-500">
                Order ID : #{order.channelOrderId || order.orderId}
              </div>

              {/* Weight Comparison Row */}
              <div className="flex justify-between items-center bg-red-50 text-[10px] text-gray-700 px-3 py-2">
                <div className="text-red-600 font-[600]">
                  Charged Weight: {order.chargedWeight.applicableWeight} Kg
                </div>
                <div className="text-gray-500">
                  Applied Weight: {order.enteredWeight.applicableWeight} Kg
                </div>
              </div>

              {/* Raised Date + Action */}
              <div className="flex justify-between items-center px-3 py-2 text-gray-500">
                <p>
                  Discrepancy Raised On:{" "}
                  <span className="font-[600]">
                    {new Date(order.createdAt).toLocaleDateString("en-IN", {
                      day: "2-digit",
                      month: "short",
                      year: "numeric",
                    })}
                  </span>
                </p>
                <p className="font-bold text-[12px] text-gray-500">₹{order.excessWeightCharges.pendingAmount}</p>
              </div>



              {/* User Details */}
              <div className="bg-purple-50 px-3 py-2 border-t flex justify-between items-center text-[10px] text-gray-700">
                <div className="space-y-1">
                  <p className="font-[600]">{order.user.name}</p>
                  <p>{order.user.phoneNumber}</p>
                  <p className="text-[#632C9D] truncate">{order.user.email}</p>
                </div>
                <span className="text-[10px] font-[600] text-purple-700 bg-purple-100 px-2 py-1 rounded">
                  {order.adminStatus}
                </span>
              </div>
            </div>
          ))
        )}
      </div>

      {/* Pagination Controls */}
      <div className="flex justify-between items-center mt-4">
        <div className="text-sm text-gray-600">
          Showing {(page - 1) * limit + 1} to {Math.min(page * limit, total)} of{" "}
          {total} results
        </div>
        <div className="flex space-x-2 items-center">
          <button
            onClick={() => setPage((prev) => Math.max(1, prev - 1))}
            disabled={page === 1}
            className="px-3 py-1 border rounded disabled:opacity-50"
          >
            Prev
          </button>
          <span className="text-sm">{page}</span>
          <button
            onClick={() =>
              setPage((prev) => (prev * limit < total ? prev + 1 : prev))
            }
            disabled={page * limit >= total}
            className="px-3 py-1 border rounded disabled:opacity-50"
          >
            Next
          </button>
          <select
            value={limit}
            onChange={(e) => {
              const val = e.target.value;
              setLimit(val === "all" ? total : parseInt(val));
              setPage(1);
            }}
            className="ml-2 p-1 border rounded text-sm"
          >
            {pageOptions.map((opt) => (
              <option key={opt} value={opt}>
                {opt}
              </option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
};

export default CompleteWeightDiscrepancy;
